export default __webpack_public_path__ + "static/media/truck-plain.32af5ae9.svg";